import ManyToOne from './ManyToOne'
export default {
  install(Vue) {
    Vue.component('ManyToOne', ManyToOne)
  },
}
